<template>
  <div ref="imageEditorGallery" class="gallery_lfp justified-gallery">
    <a
      v-for="item in items"
      :key="item.id"
      class="gallery-item imageItem image-item gallery-item"
    >
      <div class="actions">
        <div class="drag" draggable="true" @dragstart="startDrag($event, item)">
          <appAwesomeIcon icon="arrows-alt" useClass="fa fa-arrows" />
          <div style="position: fixed; top: -1000px">
            <div
              class="drag-image"
              :style="{
                width: '100px',
                height: '100px',
                backgroundImage: 'url(' + item.url + ')',
                backgroundSize: 'contain',
                backgroundPosition: 'top center',
                backgroundRepeat: 'no-repeat'
              }"
            ></div>
          </div>
        </div>
        <div @click="deleteImageHandler(item.id)">
          <appAwesomeIcon
            v-if="!hideDelete"
            icon="trash-alt"
            useClass="fa fa-trash-o"
          />
        </div>
      </div>
      <div class="animation-container">
        <div class="loader-animation">
          <div v-for="(time, index) in animationTimes" :key="index"></div>
        </div>
      </div>
      <img
        :id="getImageId(item)"
        class="galleryImageItem image-item gallery-item"
        :src="item.url"
      />
    </a>
  </div>
</template>
<script>
import { useCustomerStore } from "@/stores/modules/customer";
import { mapState, mapActions } from "pinia";

import "justifiedGallery/dist/css/justifiedGallery.css";
import "justifiedGallery/dist/js/jquery.justifiedGallery";
import * as R from "ramda";

export default {
  components: {},
  props: ["items", "hideDelete"],
  data: () => {
    return {
      animationTimes: R.times(R.identity, 23)
    };
  },
  computed: {},
  methods: {
    ...mapActions(useCustomerStore, ["deleteCustomerImage"]),
    getImageId(item) {
      return "dragPreview_" + item.id;
    },
    deleteImageHandler(uuid) {
      this.deleteCustomerImage(uuid);
    },
    startDrag(event, item) {
      event.dataTransfer.dropEffect = "move";
      event.dataTransfer.setData("id", item.id);
      event.dataTransfer.setData("type", "local_image");
      var image = document.getElementById(this.getImageId(item));
      event.dataTransfer.setDragImage(image, 0, 0);
    }
  },
  mounted() {
    jQuery(this.$refs.imageEditorGallery).justifiedGallery({
      margins: 10,
      rowHeight: 100
    });
  },
  updated: function () {
    //jQuery(this.$refs.imageEditorGallery).justifiedGallery("norewind");
    jQuery(this.$refs.imageEditorGallery).justifiedGallery();
  }
};
</script>
